var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"screenfull",attrs:{"title":_vm.getTitle(),"id":"meeting_screenfull_btn_headless"},on:{"click":_vm.click}},[_c('img',{staticClass:"myIcon",attrs:{"src":_vm.isFullModel ? _vm.suofangquanping : _vm.quanping}})])}
var staticRenderFns = []

export { render, staticRenderFns }